import axios from 'axios'

// Rails renders the token into a meta tag on every layout. Reading it per
// request instead of once at import time keeps the tag as the single source of
// truth, so replacing its content is enough to recover from a stale token.
export const client = axios.create()

client.interceptors.request.use((config) => {
  const token = document.querySelector<HTMLMetaElement>(
    'meta[name="csrf-token"]',
  )?.content

  if (token) config.headers['X-CSRF-Token'] = token

  return config
})

const handleUnauthorized = (error: unknown) => {
  if (
    axios.isAxiosError(error) &&
    error.response &&
    error.response.status === 401
  ) {
    window.location.reload()
    return new Promise(() => null)
  }

  throw error
}

export const getRequest = async (url: string) => {
  try {
    return await client.get(url).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const postRequest = async (url: string, data?: unknown) => {
  try {
    return await client.post(url, data ?? {}).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const putRequest = async (url: string, data: unknown) => {
  try {
    return await client.put(url, data).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const deleteRequest = async (url: string) => {
  try {
    return await client.delete(url).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const postFormData = async (url: string, formData: FormData) => {
  try {
    return await client
      .post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const putFormData = async (url: string, formData: FormData) => {
  try {
    return await client
      .put(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}
